<template>
  <div class="tw-mx-auto tw-mb-6 tw-max-w-6xl">
    <div class="tw-flex tw-flex-col">
      <VueperSlides
        :visible-slides="reviewsPerSlide"
        :gap="3"
        :touchable="false"
        :infinite="true"
        :dragging-distance="200"
        :bullets="false"
        :breakpoints="breakpoints"
        class="no-shadow"
        fixed-height="215px"
      >
        <VueperSlide v-for="review in reviews" :key="review.id">
          <template v-slot:content>
            <div class="tw-box-border tw-rounded-lg">
              <FeaturedFeedbackContainerItem
                :review="review"
                @show-feedback-modal="showFeedbackModal"
                :pt="{ content: { class: '!tw-py-3.5 !tw-min-h-[116px]' } }"
              />
            </div>
          </template>
        </VueperSlide>
      </VueperSlides>
    </div>
  </div>
  <FeedbackModal v-if="modalReview" v-model:visible="isFeedbackModalVisible" :review="modalReview" />
</template>

<script setup>
import { ref } from 'vue';
import { VueperSlide, VueperSlides } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import FeaturedFeedbackContainerItem from './FeaturedFeedbackContainerItem.vue';
import FeedbackModal from './FeedbackModal.vue';

defineProps({
  reviews: Array,
  reviewsPerSlide: Number,
});

let modalReview = ref(null);
let isFeedbackModalVisible = ref(false);

const breakpoints = {
  1200: {
    slideRatio: 1 / 5,
  },
  900: {
    slideRatio: 1 / 3,
    visibleSlides: 2,
    slideMultiple: 2,
  },
  640: {
    slideRatio: 1 / 2,
    visibleSlides: 1,
    slideMultiple: 1,
  },
};

const showFeedbackModal = review => {
  modalReview.value = review;
  isFeedbackModalVisible.value = true;
};
</script>

<style>
.vueperslides--fixed-height.vueperslides--bullets-outside {
  margin-bottom: 0px;
}
.vueperslides__arrows {
  color: v-bind('$page.props.customisation.secondary_background');
}
.vueperslides__arrow--prev {
  left: -2.5em !important;
}
.vueperslides__arrow--next {
  right: -2.5em !important;
}
.vueperslides__arrow svg {
  stroke-width: 2;
  padding: 1.1em;
  width: 3em;
}
.vueperslides__track {
  @apply tw-p-0.5;
}
.header-title {
  @apply tw-px-0;
}
</style>
